<form (submit.prevent)="onSubmit()" class="flex flex-col gap-4">
  <app-parse-request-create-accordion [state]="state()" activeStep="SUMMARY">
    <div slot="summary-form" class="flex flex-col gap-6">
      <ui-alert>
        <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
        <h3 slot="title">
          {{ 'cockpit.parseRequests.createSummary.alertTitle' | transloco }}
        </h3>
        <p>
          {{ 'cockpit.parseRequests.createSummary.alertDescription' | transloco }}
        </p>
      </ui-alert>

      <div class="flex flex-col gap-2">
        <div class="flex gap-1.5 justify-start items-start">
          <input
            type="checkbox"
            id="data-agreement"
            class="mt-0.5"
            [formField]="form.dataProcessingConfirmation"
          />
          <label for="data-agreement" class="flex flex-col gap-0.5">
            <p class="text-sm">
              {{
                'cockpit.parseRequests.createSummary.dataProcessingConfirmationLabel' | transloco
              }}
            </p>
            <p class="text-xs text-on-surface-variant dark:text-on-surface-variant-darkmode">
              {{
                'cockpit.parseRequests.createSummary.dataProcessingConfirmationSubtext' | transloco
              }}
            </p>
          </label>
        </div>
        <app-field-errors [fieldState]="form.dataProcessingConfirmation()" />
      </div>

      <div class="flex flex-col gap-2">
        <div class="flex gap-1.5 justify-start items-start">
          <input
            type="checkbox"
            id="confirmation"
            class="mt-0.5"
            [formField]="form.contentAllowanceConfirmation"
          />
          <label for="confirmation" class="flex flex-col gap-0.5">
            <p class="text-sm">
              {{
                'cockpit.parseRequests.createSummary.contentAllowanceConfirmationLabel' | transloco
              }}
            </p>
            <p class="text-xs text-on-surface-variant dark:text-on-surface-variant-darkmode">
              {{
                'cockpit.parseRequests.createSummary.contentAllowanceConfirmationSubtext'
                  | transloco
              }}
            </p>
          </label>
        </div>
        <app-field-errors [fieldState]="form.contentAllowanceConfirmation()" />
      </div>

      <div class="empty:hidden text-end">
        @if (showValidationErrors() && form().invalid()) {
          <ui-input-error>
            {{ 'cockpit.parseRequests.createSummary.validationError' | transloco }}
          </ui-input-error>
        }

        @if (updateError()) {
          <ui-input-error>
            {{ 'cockpit.parseRequests.createSummary.updateError' | transloco }}
          </ui-input-error>
        }
      </div>
    </div>

    <div slot="summary-footer" class="grid grid-cols-1 gap-2 @md/summary-footer:grid-cols-2">
      <div class="@md/summary-footer:flex">
        <ui-button
          type="button"
          expand="full"
          mode="outlined"
          [routerLink]="['../general']"
          [relativeTo]="activatedRoute"
        >
          <ng-icon name="heroChevronLeft" size="20" class="!block" slot="start" />
          {{ 'cockpit.parseRequests.createSummary.backButton' | transloco }}
        </ui-button>
      </div>
      <div class="@md/summary-footer:flex justify-end gap-2">
        <ui-button
          type="submit"
          expand="full"
          [disabled]="isUpdateLoading()"
          [loading]="isUpdateLoading()"
        >
          {{ 'cockpit.parseRequests.createSummary.submitButton' | transloco }}
          <ng-icon name="heroChevronRight" size="20" class="!block" slot="end" />
        </ui-button>
      </div>
    </div>
  </app-parse-request-create-accordion>
</form>
